import { TCPA } from "@lgp/shared/constants";
import parse, { attributesToProps, domToReact } from "html-react-parser";
import { useMemo } from "react";
import { substitutions } from "../../utils/string";

const parseOptions = {
  replace: (domNode) => {
    if (domNode.attribs && domNode.name === "a") {
      const props = attributesToProps(domNode.attribs);
      return (
        <a {...props} target="_blank" rel="noreferrer">
          {domToReact(domNode.children)}
        </a>
      );
    }
  },
};

const useTcpaMemo = (content, replacements = {}) => {
  const memoContent = useMemo(
    function memoizedContent() {
      if (content) {
        let newContent = content;
        if (newContent.indexOf("home service partners") > -1) {
          newContent = content.replace(
            "home service partners",
            `home service <a href="${TCPA.TCPA_S3_BASE_URL}/partners.html" target="_blank" rel="noreferrer">partners</a>`
          );
        }

        return parse(substitutions(newContent, replacements), parseOptions);
      }

      return "";
    },
    [content, replacements]
  );

  return memoContent;
};

export default useTcpaMemo;
